import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';

@Component({
  selector: 'my-privacy-full',
  template: require('./privacy-full.component.html'),
  styles: [require('./privacy-full.component.scss'), require('../shared/styles/form.scss')]
})
export class PrivacyFullComponent implements OnInit {

  constructor(
    private loadingService: LoadingService,
    private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    console.log('privacy Full');
    this.loadingService.hideLoading();
  }
  gotoLogin() {
    this.router.navigate(['/login']);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/privacy-full/privacy-full.component.ts